import { UploadOutlined } from '@ant-design/icons';
import { unwrapResult } from '@reduxjs/toolkit';
import { Button, Col, Row, Spin } from 'antd';
import * as echarts from 'echarts';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { MoneyLine, PenNumberLine } from '../../../compnents/icons/Icons';
import { Label } from '../../../compnents/widgets/Label';
import { echartsLine } from '../../../models/echartsData';
import { getBackgroundColor, getOrganizationPlaneName } from '../../../models/monitoring';
import { UpdateTime } from '../components/time';
import { getAddServicesData, getDataList, getTendencyChart } from '../monitoringPageSlice';
import styles from '../monitoringTab.module.css'

interface AddServicesPageProps {
  state: string
}

export const AddServicesPage = ({ state }: AddServicesPageProps): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const topRef = useRef<HTMLDivElement>(null)
  const centerRef = useRef<HTMLDivElement>(null)
  const bottomRef = useRef<HTMLDivElement>(null)

  const [dataNum, setDataNum] = useState(0)    //开通机构or服务笔数or运营金额or运营笔数

  const [listData, setListData] = useState<any>({})

  const [topList, setTopList] = useState<any>()

  const [listLoading, setListLoading] = useState(false) // 全部、好医点、聚网 loading


  const [lineChartData, setLineChartData] = useState<any>()    //近一年增值服务机构趋势图数据

  const [centerlineChartData, setCenterlineChartData] = useState<any>()    //近一年增值服务运营趋势图数据

  const [bottomlineChartData, setBottomlineChartData] = useState<any>()    //近一年产品中心趋势图数据


  const list = [
    { name: 'orderNum', num: 'newOrderNum', color: 1, icon: <PenNumberLine /> },
    { name: 'productMoney', num: 'newProductMoneyMoney', color: 2, icon: <MoneyLine /> },
  ]

  const refList = [
    { name: topRef, id: 6, title: true, titleType: 'addedServices', rightNum: 6, data: lineChartData },
    { name: centerRef, id: 7, title: true, titleType: 'addedServicesOperating', rightNum: 7, data: centerlineChartData },
    { name: bottomRef, id: 9, title: false, titleType: 'productCenter', rightNum: 9, data: bottomlineChartData },
  ]

  const result = (str: string) => {
    return (str == '机构数据' || str == '用户数据' || str == '患者就诊' || str == '结算' || str == '病历数据' || str == '预约数据')
  }

  const bgcFn = (type: number) => {
    switch (type) {
      case 1:
        return '#e2ecff'
      case 2:
        return '#ffd9e8'
      case 3:
        return ' #e5ffeb'
      default:
        return '#fff';
    }
  }

  const borderFn = (type: number) => {
    switch (type) {
      case 1:
        return '1px solid #87affa'
      case 2:
        return '1px solid  #ff70a9'
      case 3:
        return '1px solid  #93d678'
      default:
        return '#fff';
    }
  }

  const getDoctorLineChart = (num: number): any => { //折线图数据
    dispatch(getTendencyChart({
      trendChartType: num,
    }))
      .then(unwrapResult)
      .then((t: any) => {
        if (num == 5 || num == 6) {
          setLineChartData(t)
        } else if (num == 7 || num == 8) {
          setCenterlineChartData(t)
        } else if (num == 9) {
          setBottomlineChartData(t)
        }

      })
  }
  useEffect(() => {   // 全部、好医点、聚网
    if (!dataNum) return
    getDoctorLineChart(dataNum)
  }, [dataNum])

  useEffect(() => {
    setListLoading(true)
    dispatch(getDataList())  //数据看板数据
      .then(unwrapResult)
      .then((res: any) => setTopList(Object.entries(res).filter((item: any) => !result(item[0]))))
      .finally(() => setListLoading(false))
    dispatch(getAddServicesData())   //数据看板数据
      .then(unwrapResult)
      .then((res: any) => setListData(res))
      .finally(() => setListLoading(false))
    refList.forEach((item: any) => {   //折线图数据
      getDoctorLineChart(item.rightNum)
    })

  }, [])

  useEffect(() => {   //渲染折线图
    if (dataNum == 5 || dataNum == 6) {
      refList[0].id = dataNum
    } else if (dataNum == 7 || dataNum == 8) {
      refList[1].id = dataNum
    }
    setTimeout(() => {

      refList.forEach((item: any) => {
        lineEcharts(item.name, item.title, item.titleType, item.data, item.id)
      })
    }, 200)
  }, [topRef, centerRef, bottomRef, lineChartData, centerlineChartData, bottomlineChartData])


  const lineEcharts = (refStr: any, title: boolean, titleType: string, data: any, id: number) => {
    if (!refStr.current) return
    const myChart = echarts.init(refStr?.current);
    myChart.setOption(echartsLine(data, !title, titleType, id));
  }

  useEffect(() => {   //缓存tab 栏
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])
  return (
    <div className={styles.containers}>
      <div className={styles.content}>
        <UpdateTime time={listData?.dataTime} showSelect={false} />
        <Spin spinning={listLoading} >
        <Row gutter={20} className={styles.planContainer}>
          {
            list.map((v: any, i: number) => (
              <Col key={v.name} flex={'20%'} >
                <div className={`${styles.planItem} ${styles.layout}`}>
                  <div className={styles.planIcon}
                    style={{ backgroundColor: getBackgroundColor(v.color) }}>
                    {v.icon}
                  </div>
                  <div className={styles.planData}>
                    {getOrganizationPlaneName(v.name)}

                    {listData[v.name] && <div className={styles.titleWrap}>
                      <div className={styles.titleText}>{listData[v.name]}</div>
                      <div className={styles.titleText2}> ({listData[v.num]})</div>
                    </div>}
                  </div>
                </div>
              </Col>
            ))
          }
        </Row>

          <Row gutter={[30, 30]} style={{ marginBottom: 20 }}>
          {topList && topList.map((item: any) => {
            return (
              <Col span={6} key={item[0]}>
                <div className={styles.itemContent2} style={{ background: bgcFn(item[1][0].type), border: borderFn(item[1][0].type) }}>
                  <Label ml={'20px'} label={item[0]} />
                  {item[1].map((val: any) => {
                    return (
                      <div style={{ paddingLeft: '25px' }} key={val.id}>
                        <span className={styles.listContentItemText}>{val.itemName}: </span>
                        <span className={styles.listContentItemTextValue}>{val.itemValue}</span>
                        <span className={styles.listContentItemTextNum}> ({val.highlightValue})</span>
                      </div>
                    )
                  })}
                </div>
              </Col>
            )
          })}
        </Row>
        </Spin>
        {refList.map((item: any) => {
          return (
            <div key={item.id}>
              <Row className={`${styles.planContainer}`}>
                <Col flex={1}>
                  <div className={styles.layout}>
                    {/* 标题 */}
                    {item.title && <UpdateTime titleType={item.titleType} btnNum={item.rightNum} select={(v) => setDataNum(v)} />}
                    {/* 折线图 */}
                    <div ref={item.name} className={styles.echartsLine}></div>
                  </div>
                </Col>
              </Row>
            </div>
          )
        })}
      </div>
    </div>
  );
}

